import classNames from 'classnames';
import ResponsiveCarousel from 'components/common/ResponsiveCarousel';
import { FunctionComponent } from 'react';
import { ExperienceSummary } from 'types/experience/experience-summary.type';
import ExperienceCard from './ExperienceCard';

interface SuggestedExperiencesProps {
  experiences: ExperienceSummary[];
  className?: string;
}

const SuggestedExperiences: FunctionComponent<SuggestedExperiencesProps> = ({
  experiences,
  className,
}) => {
  return (
    <section
      className={classNames('suggested-vehicles flex gap-12', className)}
    >
      <ResponsiveCarousel>
        {experiences.map((experience, id) => (
          <ExperienceCard experience={experience} key={id} />
        ))}
      </ResponsiveCarousel>
    </section>
  );
};

export default SuggestedExperiences;
